import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@/components/ui/Icon";

interface BenefitListProps {
	items: string[];
}

/** Benefit list with brand-teal checkmarks (icon + text, not colour alone). */
function BenefitList(prop: BenefitListProps) {
	const { items } = prop;
	return (
		<ul className="flex flex-col gap-3">
			{items.map((item) => (
				<li key={item} className="flex items-start gap-3">
					<span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-[color-mix(in_srgb,var(--brand-2)_16%,transparent)] text-(--brand-2)">
						<Icon icon={faCheck} size={13} />
					</span>
					<span className="text-[15px] leading-snug text-text">{item}</span>
				</li>
			))}
		</ul>
	);
}

export default BenefitList;
